import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { get } from "../lib/api";
import { Seo } from "../lib/seo";
import { Section, Button } from "../components/ui";

export default function CheckoutSuccess() {
  const [sp] = useSearchParams();
  const orderId = sp.get("order_id");
  const type = sp.get("type") || "subscription";
  const [status, setStatus] = useState(null);
  useEffect(() => {
    if (!orderId) return;
    let n = 0; let timer;
    const poll = async () => {
      try { const s = await get(`/orders/${orderId}`); setStatus(s); if ((s.provisioning_status === "complete" || s.status === "complete") || n > 10) return; }
      catch (e) {}
      n++; timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [orderId]);
  const done = status && (status.provisioning_status === "complete" || (status.type === "credits" && status.status === "complete"));
  return (
    <>
      <Seo title="Checkout" path="/checkout/success/" noindex description="Order status" />
      <Section>
        <div className="max-w-lg mx-auto text-center py-16">
          {!orderId ? (
            <><h1 className="text-3xl text-ink-950">No order found.</h1><p className="mt-3 text-ink-600">Head back to pricing to start a plan.</p><Button to="/pricing/" variant="primary" size="lg" className="mt-6">View pricing</Button></>
          ) : done ? (
            <><h1 className="text-3xl text-ink-950">You're all set.</h1><p className="mt-3 text-ink-600">{type === "credits" ? "Your credits have been added." : "Your account is ready. Sign in to get started."}</p><Button href="https://app.connect.bybloomlabs.com/v2/" variant="primary" size="lg" className="mt-6">Sign in</Button></>
          ) : (
            <><h1 className="text-3xl text-ink-950">Setting up your account…</h1><p className="mt-3 text-ink-600">Payment received. Your account is being set up; we'll email you within the hour if it needs a moment longer.</p><div className="mt-6 font-mono text-2xs text-ink-400">Status: {status?.status || "checking"}</div></>
          )}
          <p className="mt-8 text-sm"><Link to="/" className="link">Back to home</Link></p>
        </div>
      </Section>
    </>
  );
}
